import React from 'react';
import SearchComponent from './SearchComponent';
import Navbar from './Navbar';
import HeroBackground from '../assets/Rectangle 182.webp';

function Header() {
  return (
    <header className="relative text-white text-center">
      <Navbar />
      
      {/* Contenedor de la imagen con altura fija - REDUCIDA en mobile */}
      <div className="relative h-[180px] md:h-[500px] lg:h-[600px] overflow-hidden">
        <img
          src={HeroBackground}
          alt="Hero Background"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
          fetchpriority="high"
        />
        {/* Overlay oscuro opcional para mejor legibilidad */}
        <div className="absolute inset-0 bg-black/10"></div>

        {/* Título centrado verticalmente - OCULTO en mobile */}
        <div className="hidden md:flex absolute inset-0 items-center justify-center">
          <p className="text-4xl lg:text-5xl xl:text-6xl font-bold font-montserrat drop-shadow-2xl px-4 max-w-5xl leading-tight">
            Viaja, Disfruta y viví una vida llena de aventuras
          </p>
        </div>
      </div>
      
      {/* Buscador - En mobile más pegado a la imagen */}
      <div className="relative -mt-12 md:-mt-24 lg:-mt-20 z-20 container mx-auto px-3 md:px-4">
        <div className="shadow-[0_10px_40px_rgba(0,0,0,0.6)] rounded-3xl">
          <SearchComponent />
        </div>
      </div>
    </header>
  );
}

export default Header;